import { Box } from "@mui/material";
import { color, display, fontSize, styled, textAlign, width } from "@mui/system";
import { Colors } from "./theme";
import zIndex from "@mui/material/styles/zIndex";
import { borderRadius, padding } from "polished";

export const DashBoardContainer = styled(Box)(() => ({
  "& .dashboard-container": {
    transition: "all 0.3s ease-in-out",
    width: "100%",
  },
  "& .action-gap": {
    display: "flex",
    gap: "10px",
    "& a svg": {
      textDecoration: "none",
      color: Colors.black,
      "&:hover": {
        color: Colors.hover,
      },
    },
  },
  "& .header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 10px",
  },

  "& .search-box": {
    padding: "8px 12px",
    width: "250px",
    borderRadius: "5px",
    border: "1px solid " + Colors.border,
    fontSize: "12px",
    fontWeight: "500",
    outline: "none",
  },

  "& .header-input": {
    display: "flex",
    alignItems: "center",
    position: "relative",
  },

  "& .search-icon": {
    position: "absolute",
    right: "10px",
    fontSize: "20px",
    color: Colors.garyText,
    cursor: "pointer",
  },

  "& .create-button": {
    backgroundColor: Colors.primary,
    color: Colors.white,
    border: "none",
    padding: "8px 15px",
    borderRadius: "3px",
    cursor: "pointer",
  },

  "& .floating-action-button": {
    position: "fixed",
    bottom: "40px",
    right: "40px",
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: Colors.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: Colors.white,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
    cursor: "pointer",
    zIndex: "1000",
    transition: "all 0.3s ease",
  },

  "& .floating-action-button:hover": {
    backgroundColor: Colors.hover /* Slightly darker on hover */,
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.4)",
    transform: "scale(1.05) translateY(-2px)",
  },

  "& .lms-list": {
    display: "grid",
    gap: "15px",
    padding: "10px",
    gridTemplateColumns: "repeat(3, 1fr)",
    transition: "all 0.3s ease-in-out",
  },

  "& .lms-card": {
    boxShadow:"rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",  
    background: "white",
    borderRadius: "10px",
    position: "relative",
    "& .Description":{
      textAlign:"right",
      width :"65%"
    }
  },

  "& .card-id-badge": {
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: Colors.primary,
    color: "white",
    padding: "2px 8px",
    zIndex: 1,
    borderRadius: "8px 0px 0px 0px",
    fontWeight: "bold",
  },
  "& .sub-header": {
    display: "flex",
    alignItems: "center",
    backgroundColor: Colors.gray,
    borderRadius: "5px",
    color: "white",
    padding: "16px 10px",
    fontSize: "12px",
    fontWeight: "500",
    margin: "10px",
  },
  "& .card-body": {
    backgroundColor: Colors.white,
    borderRadius: "10px",
    border: "1px solid " + Colors.border,
    marginTop: "-10px",
    position: "relative",
    zIndex: "1",
  },

  "& .card-body p": {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 10px",
    fontSize: "12px",
  },

  "& .card-body strong , .text-read-more": {
    fontSize: "12px",
  },

  ".card-top-image": {
    width: "100%",
    height: "150px",
    objectFit: "cover",
    cursor: "pointer",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    margin: 0,
    padding: 0,
    display: "block",
  },

  "& .actions": {
    position: "absolute",
    right: "0px",
    bottom: "0px",
    marginTop: "10px",
  },

  "& .approve-button": {
    padding: "6px 10px",
    border: "none",
    borderRadius: "3px 0px 8px 3px",
    cursor: "pointer",
    fontSize: "12px",
  },

  "& .modal-overlay": {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1000",
  },

  "& .modal-content": {
    background: Colors.white,
    width: "350px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    position: "relative",
    paddingBottom: "20px",
  },

  "& .close-button": {
    background: "none",
    outline: "none",
    border: "none",
    color: "white",
    cursor: "pointer",
  },

  "& .close-button:hover": {
    color: "rgb(233, 228, 228)",
    transform: "scale(1) translate(1px,-1px)",
    transition: "transform 0.1s ease, color 0.1s ease",
  },

  "& .modal-header": {
    width: "100%",
    padding: "0px 14px",
    height: "30px",
    color: Colors.white,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: Colors.primary,
    marginBottom: "10px",
  },

  "& .input-wrapper": {
    padding: "0 10px",
  },

  "& .modal-input": {
    display: "block",
    margin: "10px auto",
    width: "100%",
    border: "1px solid " + Colors.border,
    borderRadius: "5px",
    padding: "5px",
    fontSize: "12px",
  },

  "& .input-para input ": {
    marginTop: "0",
  },

  "& .modal-inputs-2": {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  },

  "& .input-para": {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },

  "& .input-para p": {
    fontSize: "12px",
    fontWeight: "500",
    marginBottom: "5px",
  },
  "& .input-para textarea ": {
    marginTop: "0",
    fontSize: "12px",
    fontWeight: "500",
  },
  "& .btn": {
    marginTop: "30px",
  },

  "& .submit-button": {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    backgroundColor: Colors.primary,
    color: "white",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: "700",
  },

  "& .paragraphs p": {
    fontWeight: "500",
    fontSize: "12px",
  },

  "& .read-more-container": {
    marginLeft: "30px",
  },

  "& .course-category": {
    marginBottom: "10px",
    fontSize: "12px",
    fontWeight: "500",
  },
  "& .course-category p": {
    marginBottom: "5px",
  },
  "& .card-image-container": {
    position: "relative",
    width: "100%",
    display: "inline-block",
    overflow: "hidden",
    borderRadius: "8px 8px 0 0",
    aspectRatio: "16/9",
  },
  ".card-image-container img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.2s ease",
  },
  ".card-image-container img:hover": {
    transform: "scale(1.02)",
  },
  "& .image-icon-container":{
    padding: "5px 8px",
    backgroundColor:"#fff",
    borderRadius: "50%",
    position: "absolute",
    right:"5px",
    top: "5px",
    cursor: "pointer",
    zIndex:"10",
  },
  "& .img-icon ":{
    color : Colors.primary,
  },

  "& .course-category select": {
    width: "100%",
    padding: "5px",
    border: "1px solid " + Colors.border,
    borderRadius: "5px",
    fontSize: "12px",
  },

  "& .cropper-modal": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.2)",
    borderRadius: "5px",
    padding: "0",
    outline: "none",
    width: "80%",
    maxWidth: "500px",
  },

  "& .cropper-header": {
    backgroundColor: Colors.primary,
    color: "white",
    padding: "10px 15px",
    fontWeight: "bold",
    borderRadius: "5px 5px 0 0",
  },

  "& .cropper-preview-container": {
    position: "relative",
    height: "300px",
    width: "100%",
  },

  "& .cropper-actions": {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 15px",
    gap: "10px",
  },

  "& .upload_button": {
    backgroundColor: Colors.primary,
    color: "white",
    border: "none",
    padding: "8px 15px",
    borderRadius: "3px",
    cursor: "pointer",
  },

  "& .cancel-button": {
    backgroundColor: Colors.primary,
    color: "white",
    border: "none",
    padding: "8px 15px",
    borderRadius: "3px",
    cursor: "pointer",
  },

  "& .infinite-scroll-loading": {
    textAlign: "center",
    padding: "20px",
  },

  "& .infinite-scroll-end": {
    textAlign: "center",
    padding: "20px",
  },

  "@media (max-width: 1200px)": {
    "& .lms-list": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },

  "@media (max-width: 768px)": {
    "& .lms-list": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },

    "& .search-box": {
      fontSize: "1rem",
      marginTop: "35px",
      width: "100%",
    },

    "& .lms-card": {
      minWidth: "100%",
      margin: "5px 0",
    },

    "& .header": {
      marginTop: "0px",
      flexDirection: "column",
      alignItems: "stretch",
      padding: "10px 5px",
      gap: "10px",
    },

    "& .header-input": {
      width: "100%",
      margin: "0",
    },
    "& .search-icon": {
      right: "10px",
      marginBottom: "-16%",
      transform: "translateY(-50%)",
    },

    "& .create-button": {
      marginTop: "5px",
      width: "100%",
      padding: "10px",
    },

    "& .modal-inputs-2": {
      flexDirection: "column",
      gap: "0",
    },

    "& .cropper-preview-container": {
      height: "250px",
    },

    "& .floating-action-button": {
      bottom: "30px",
      right: "30px",
    },
  },

  "@media (max-width: 599px)": {
    "& .dashboard-container": {
      marginTop: "-60px",
    },

    "& .cropper-modal": {
      width: "95%",
    },

    "& .cropper-preview-container": {
      height: "200px",
    },

    "& .floating-action-button": {
      bottom: "20px",
      right: "20px",
      width: "48px",
      height: "48px",
    },
  },

  "@media (max-width: 480px)": {
    "& .header-input":{
      marginTop:"18px",
    },
    "& .modal-content": {
      width: "95%",
      maxWidth: "350px",
      margin: "0 auto",
    },

    "& .input-wrapper": {
      padding: "0 10px",
    },

    "& .modal-input": {
      fontSize: "12px",
    },

    "& .modal-inputs-2": {
      flexDirection: "column",
      gap: "0",
    },

    "& .input-para": {
      fontWeight: "500",
      fontSize: "12px",
      width: "100%",
    },
  },
  "& .course-featured":{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "5px",
    fontSize: "12px",
  }
}));
